<template>
  <div>
    <Modal
      v-show="showModal"
      @cerrar="handleCerrar"
      :linea="true"
      :footer="false"
      mensajeHeader="Alta de compra"
      :flagHidden="true"
      colorSeparador="background: #012a56 0% 0% no-repeat padding-box;"
    >
      <div class="body-container">
        <div class="autocomplete-wrapper">
          <label>Proveedor*</label>
          <v-autocomplete
            v-model="idProveedor"
            :items="proveedores"
            item-text="company_name"
            item-value="_id"
            validate-on-blur
            single-line
            hide-details="true"
            placeholder="Seleccione un proveedor"
          ></v-autocomplete>
        </div>
        <Input
          :labelMod="true"
          v-model="folioFactura"
          :heigthModal="true"
          class="inputwidth"
          placeholder="Máximo 50 caracteres"
          :flagBorder="true"
          :height50="true"
          :flagSobra="true"
          :flagLabel="true"
          :isBuscador="true"
          label="Folio de factura"
          :maxlength="50"
          @update:modelValue="getFolio"
        ></Input>
        <div class="fecha" v-show="incluyeFactura">
          <DropDown
            id="fechaFactura"
            :flagLabel="true"
            :fechaExterna="fechaFactura.fecha"
            :selectOption="fechaFactura.value"
            label="Fecha factura*"
            :minDate="false"
            :maxDate="false"
            :heigthModal="true"
            @activeCalendar="activarModalCalendario"
            @actualizarFechas="cambioFechas"
          ></DropDown>
        </div>
        <div class="contenedor-detalle">
          <span>Detalles de la compra</span>
          <div class="contenedor-buscador-producto">
            <div class="autocomplete-wrapper-producto">
              <v-autocomplete
                @change="addItemToCart"
                placeholder="Busque o seleccione un producto"
                v-model="selectedProduct"
                :items="productos"
                item-text="name"
                item-value="_id"
                label="Producto*"
                validate-on-blur
                persistent-hint
                single-line
                return-object
                hide-details="true"
              ></v-autocomplete>
              <!-- solo //propiedad para el autocomplete -->
            </div>
          </div>

          <div class="cart">
            <div class="content-carrito-activo">
              <div v-for="(item, index) in cartItems" :key="item._id">
                <div class="fila-individual">
                  <p class="nombre">{{ item.name }}</p>
                  <div class="sumaResta">
                    <Btn
                      id="btnMenos"
                      :class="item.quantity == 1 ? 'btn-disable' : ''"
                      @click="
                        sumaRestaBtnCarrito('r', item, item.quantity, index)
                      "
                      >-</Btn
                    >
                    <p>{{ item.quantity }}</p>
                    <Btn
                      id="btnMas"
                      @click="
                        sumaRestaBtnCarrito('s', item, item.quantity, index)
                      "
                      >+</Btn
                    >
                  </div>
                  <div class="cantidad-eliminar">
                    <CustomMoney
                      v-model="item.costoUnitario"
                      label="Costo unitario"
                      :options="moneyOptions"
                    ></CustomMoney>
                    <CustomMoney
                      v-model="item.precio"
                      label="Precio de venta"
                      :options="moneyOptions"
                    ></CustomMoney>
                    <button id="btnEliminar" @click="removeItemFromCart(index)">
                      <v-icon icon="mdi-vuetify">mdi-delete</v-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div v-for="(item) in serviciosItems" :key="item._id">
                <div class="fila-individual">
                  <p class="nombre">{{ item.name }}</p>
                  <p>Servicio</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span v-if="altaDeServicio">*Nota: Los servicios dados de alta no se reflejarán en la orden de compra.</span>
        <div class="contenedor-alta">
          <div class="contenedor-boton-producto">
            <button class="boton-registrar producto" @click="registrarProducto">
              Alta de producto/servicio
            </button>
          </div>

          <div class="subtotales" style="text-align: end">
            <span>Subtotal: {{ getSubtotal }}</span
            ><br />
            <span>I.V.A.: {{ getIVA }}</span
            ><br />
            <span>Total: {{ getTotal }}</span>
          </div>
        </div>
        <div class="contenedor-boton">
          <button
            class="boton-registrar"
            @click="registrar"
            :disabled="getDisabled"
          >
            <span v-if="!loading">Registrar compra</span>
            <span v-else>Registrando...</span>
          </button>
        </div>
      </div>
    </Modal>
    <ModalAltaProducto
      v-if="showAltaProducto"
      @cerrar="cerrarAlta"
      @exito="exitoAlta"
      @exitoServicio="exitoServicio"
    ></ModalAltaProducto>
  </div>
</template>
<script>
import Modal from "../Modales/ModalBase.vue";
import Input from "../general/Form/Input.vue";
import Btn from "../general/Form/Button.vue";
import ApiService from "../../services/apis";
import DropDown from "../general/Form/DropCalendar.vue";
import moment from "moment";
import ModalAltaProducto from "../Modales/ModalAddProducto.vue";
import Swal from "sweetalert2";
import CustomMoney from '../general/Form/CustomMoney.vue'
import monedaMixin from "../../mixins/moneda.js";

export default {
  components: {
    Btn,
    Modal,
    Input,
    DropDown,
    ModalAltaProducto,
    CustomMoney,
  },
  data() {
    return {
      loading: false,
      moneyOptions: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      totalValido: false,
      getDisabled: true,
      subtotalG: 0,
      ivaG: 0,
      totalG: 0,
      incluyeFactura: false,
      arregloCarro: [],
      folioFactura: "",
      proveedores: null,
      idProveedor: null,
      rules: {
        required: (value) => !!value || "Requerido.",
      },
      fechaFactura: {
        value: -1,
        fecha: "DD/MM/AAAA",
      },
      mostrarCalendario: false,
      cartItems: [],
      selectedProduct: null,
      productos: null,
      timer: null,
      sesion: JSON.parse(sessionStorage.getItem("sesion")),
      showAltaProducto: false,
      showModal: true,
      data: {},
      altaDeServicio: false,
      signal: false,
      serviciosItems: [
        //  {branch: "5ff2cd16b0d8d10011803fbc",clave_unidad_sat: "E48",code: "SER-000702",code_sat: "78181500",costo: 100,createdAt: "2024-06-23T21:54:19.549Z",description: "PRUEBA",name: "SERVICIO DE PRUEBA 7",price: 200,provider: "5ffc8ee2e9a9640019fe8d3e",status: 1,type: 1,updatedAt: "2024-06-23T21:54:19.549Z",__v: 0,_id: "6678998b20c4bf21f3d702b3"}
        ],
    };
  },
  emits: ["cerrar", "exitoCompra"],
  props: {},
  methods: {
    handleCerrar() {
      if(this.altaDeServicio) {
        this.$emit("cerrarConServicio", this.serviciosItems.map((item) => item._id));
      } else {
        this.$emit("cerrar");
      }
    },
    async cargarProveedores() {
      await ApiService.proveedor().then((proveedor) => {
        this.proveedores = proveedor.data;
      });
    },
    async cargarProductos() {
      await ApiService.producto().then((producto) => {
        this.productos = producto.data;
      });
    },
    activarDrop(id) {
      if (id == 1) {
        this.showFechaFin = false;
        this.idCache = id;
      } else if (id == 2) {
        this.showFechaFin = !this.showFechaFin;
        this.idCache = id;
      }
      id = this.idCache;
    },
    reiniciarCalendario(status, id) {
      if (id == 2) {
        this.showFechaFin = status;
      }
      this.signal = false;
    },
    activarModalCalendario(statusApart) {
      this.signal = statusApart;
      this.mostrarCalendario = true;
    },
    cambioFechas(nuevaFecha) {
      this.fechaFactura.fecha = nuevaFecha;
      this.fechaFactura.value = 1;
      this.verificarBoton();
    },
    addItemToCart() {
      if (this.selectedProduct) {
        const existingItem = this.cartItems.find(
          (item) => item._id === this.selectedProduct._id
        );
        if (existingItem) {
          existingItem.quantity += 1;
        } else {
          const newItem = {
            _id: this.selectedProduct._id,
            name: this.selectedProduct.name,
            quantity: 1,
            costoUnitario: 0,
            subTotal: 0,
            precio: 0
          };
          this.cartItems.push(newItem);
        }
      }
      this.$nextTick(() => {
        this.selectedProduct = null; // Limpiar el autocomplete después de agregar
        this.verificarBoton();
      });
    },
    removeItemFromCart(index) {
      this.cartItems.splice(index, 1);
      this.verificarBoton();
    },
    removeItemFromServices(index) {
      this.serviciosItems.splice(index, 1);
    },
    sumaRestaBtnCarrito(operador, item, quantity) {
      let oldVal = quantity;
      let totalSiguiente = 0;
      let maximo = 999999999999;
      let totalActDelCarrito = 0;

      if (operador == "s" && item.quantity < 100) {
        if (totalSiguiente <= maximo && totalActDelCarrito <= maximo) {
          item.quantity++;
        }
      } else if (operador == "r" && item.quantity > 1) {
        oldVal;
        item.quantity--;
      }
      this.verificarBoton();
    },
    async registrar() {
      this.getDisabled = true
      this.loading = true
      // let arregloAux = JSON.parse(JSON.stringify(this.cartItems))
      this.arregloCarro = [...this.cartItems.map((item) => item._id), ...this.serviciosItems.map((item) => item._id)]
      //this.cartItems.map((item) => item._id); // genero el arreglo de ids para enviar al selector del punto de venta
      const formattedItems = this.cartItems.map((item) => {
        return {
          product: item._id,
          price: item.costoUnitario,
          quantity: item.quantity,
          sale_price: item.precio
        };
      });

      try {
        let obj = {
          provider: this.idProveedor,
          total: this.totalG,
          tax: this.ivaG,
          subtotal: this.subtotalG,
          purchase_detail: formattedItems,
          factura: this.folioFactura,
          fecha_compra:
            this.fechaFactura.value == -1
              ? moment().format("YYYY-MM-DD")
              : this.fechaFactura.fecha,
          user: this.sesion._id,
          employee: this.sesion.employee._id,
          branch: this.sesion.employee.branch._id,
          paymentType: "611cb7a63ebc140018e00657",
          payments: [
            {
              total: this.totalG,
              paymentType: "611cb7a63ebc140018e00657",
            },
          ],
        };
        await ApiService.compraNuevo(obj);
        this.$emit("exitoCompra", this.arregloCarro);
      } catch (error) {
        this.getDisabled = false
        this.loading = false
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.data.message,
          showConfirmButton: true,
          confirmButtonText: "Aceptar",
        });
      }
    },
    getFolio(value) {
      this.folioFactura = value;
    },
    calcularTotales() {
      this.cartItems.forEach((item) => {
        item.subTotal = item.quantity * item.costoUnitario;
      });
      const subtotal = this.cartItems.reduce(
        (accumulator, item) => accumulator + item.subTotal,
        0
      );

      const iva = subtotal * 0.16;
      const total = subtotal + iva;

      this.subtotalG = subtotal;
      this.ivaG = iva;
      this.totalG = total;
      // console.log("Subtotal de cada producto:");
      // this.cartItems.forEach((item) => {
      //   console.log(`${item.name}: ${item.subTotal}`);
      // });
    },
    verificarBoton() {
      let inactivo = true;
      // const facturaValida = this.incluyeFactura
      //   ? this.cartItems.every((item) => item.costoUnitario > 0)
      //   : true;
      const facturaValida = (this.cartItems.every((item) => item.costoUnitario > 0) && this.cartItems.every((item) => item.precio > 0)) ? true : false ;
      this.totalValido = facturaValida;

      if (
        (!this.incluyeFactura && this.cartItems.length > 0 &&
          this.totalValido &&
          this.idProveedor != null ) ||
        (this.incluyeFactura  &&
          this.fechaFactura.value != -1 && this.cartItems.length > 0 && this.totalValido && this.idProveedor != null)
      ) {
        inactivo = false;
      }

      this.getDisabled = inactivo;
    },
    registrarProducto() {
      this.showModal = false;
      this.showAltaProducto = true;
      this.data.folio = this.folioFactura;
    },
    cerrarAlta() {
      this.showAltaProducto = false;
      this.showModal = true;
      this.folioFactura = "";
      setTimeout(() => {
        this.folioFactura = this.data.folio;
      }, 100);
      this.getFolio(this.data.folio);
    },
    exitoAlta(producto) {
      this.showAltaProducto = false;
      this.cargarProductos();
      Swal.fire({
        icon: "success",
        title: "Atención!",
        text: `Producto nuevo agregado con éxito`,
        showConfirmButton: true,
        confirmButtonText: "Enterado",
      }).then((result) => {
        if (result.isConfirmed) {
          this.showModal = true;
          this.addItemToCartExito(producto)
        }
      });
    },
    exitoServicio(producto) {
      this.showAltaProducto = false;
      this.altaDeServicio = true;
      this.cargarProductos();
      Swal.fire({
        icon: "success",
        title: "Atención!",
        text: `Servicio dado de alta con éxito`,
        showConfirmButton: true,
        confirmButtonText: "Enterado",
      }).then((result) => {
        if (result.isConfirmed) {
          this.showModal = true;
          const newItem = {
            _id: producto._id,
            name: producto.name,
          };
          this.serviciosItems.push(newItem)
        }
      });
    },
    addItemToCartExito(product) {
      if (product) {
        const existingItem = this.cartItems.find(
          (item) => item._id === product._id
        );
        if (existingItem) {
          existingItem.quantity += 1;
        } else {
          const newItem = {
            _id: product._id,
            name: product.name,
            quantity: 1,
            costoUnitario: 0,
            subTotal: 0,
            precio:0
          };
          this.cartItems.push(newItem);
        }
      }
      this.$nextTick(() => {
        this.selectedProduct = null; 
        this.verificarBoton();
      });
    },
    getCosto(value, index) {
      // this.cartItems[index].costoUnitario = value;
      this.$set(this.cartItems[index], 'costoUnitario', value);
    },
    getPrecio(value, index) {
      // this.cartItems[index].precio = value;
      this.$set(this.cartItems[index], 'precio', value);
    },
  },
  async created() {
    await this.cargarProductos();
  },
  computed: {
    getSubtotal() {
      return "$" + monedaMixin.formatPrice(this.subtotalG);
    },
    getIVA() {
      return "$" + monedaMixin.formatPrice(this.ivaG);
    },
    getTotal() {
      return "$" + monedaMixin.formatPrice(this.totalG);
    },
  },
  async beforeMount() {
    await this.cargarProveedores();
  },
  watch: {
    cartItems: {
      handler(newCartItems) {
        this.calcularTotales();
        // const facturaValida = this.incluyeFactura
        //   ? newCartItems.every((item) => item.costoUnitario > 0)
        //   : true;
        const facturaValida = newCartItems.every(
          (item) => item.costoUnitario > 0 && item.precio > 0
        );
        this.totalValido = facturaValida;
        this.verificarBoton();
      },
      deep: true, // Observar cambios profundos en cartItems (propiedades anidadas)
    },
    folioFactura() {
      this.incluyeFactura = false;
      if (this.folioFactura.length > 0) {
        this.incluyeFactura = true;
      } else {
        this.idProveedor = null;
        this.fechaFactura.value = -1;
        this.fechaFactura.fecha = "DD/MM/AAAA";
      }
      this.verificarBoton();
    },
    idProveedor() {
      this.verificarBoton();
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0 !important;
}
.body-container {
  width: 941px;
  height: auto;
  display: flex;
  flex-direction: column;
  color: #707070 !important;
  padding: 0 30px;
  margin-top: 20px;
  transition: all 0.4s;
  transition: 0.7s all ease-in-out;
}
.modal-header span {
  color: #707070 !important;
}
.separador {
  width: 100%;
  margin: 13px 0;
  border-bottom: 1px solid rgb(112, 112, 112, 0.39);
}
.separadorGrueso {
  width: 238px;
  height: 6px;
  background: #000000 0% 0% no-repeat padding-box;
  position: absolute;
  top: 86px;
}
.autocomplete-wrapper label {
  position: relative;
  top: -11px;
  width: unset;
  padding: 0px 10px;
  text-align: center;
  margin-left: 30px;
  background: white;
}
.inputwidth {
  margin-top: 20px;
}
.money {
  width: 200px;
}
.autocomplete-wrapper {
  margin-top: 20px;
  border-radius: 0px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #404040;
  width: 100%;
  transition: all 0.6s;
  transition: 0.7s all ease-in-out;
}

.autocomplete-wrapper .v-input__slot {
  font-size: 14px;
  margin-bottom: 0 !important;
}

.autocomplete-wrapper .v-input__slot input {
  color: #333;
  margin-bottom: 0 !important;
}
.v-input__slot {
  margin-bottom: 0 !important;
}
.v-text-field {
  margin-top: 0 !important;
  padding-top: 0 !important;
  padding-left: 10px;
}
.autocomplete-wrapper-producto {
  border-radius: 0px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #404040;
  width: 80%;
  transition: all 0.8s;
  transition: 0.1s all ease-in-out;
}
.autocomplete-wrapper-producto .v-text-field {
  margin-top: 12px !important;
}
#fechaFactura {
  margin-top: 20px;
}
.contenedor-detalle {
  border-radius: 0px;
  box-shadow: 0px 3px 6px #00000029;
  -webkit-box-shadow: 0px 3px 6px #00000029;
  -moz-box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #404040;
  height: 385px;
  max-height: 404px;
  width: 100%;
  position: relative;
  margin-top: 20px;
  transition: all 0.12s;
  transition: 0.14s all ease-in-out;
}
.contenedor-detalle span {
  position: relative;
  top: -11px;
  width: unset;
  padding: 0px 10px;
  text-align: center;
  margin-left: 30px;
  background: white;
}
.contenedor-buscador-producto {
  display: flex;
  justify-content: end;
  margin-right: 30px;
}
.contenedor-boton {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}
.boton-registrar {
  width: 170px;
  height: 40px;
  color: white;
  background-color: #012a56;
  border-radius: 6px;
  box-shadow: 0px 3px 6px #00000029;
  -webkit-box-shadow: 0px 3px 6px #00000029;
  -moz-box-shadow: 0px 3px 6px #00000029;
  cursor: pointer;
}
.boton-registrar:disabled {
  background: #d1d1d1 0% 0% no-repeat padding-box;
  border: none;
  cursor: not-allowed;
}
.content-carrito-activo {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 25px 0px;
  overflow-y: auto;
  max-height: 300px;
  padding: 0 20px;
}
.fila-individual {
  display: flex;
  align-items: center;
  gap: 20px;
  height: auto;
  min-height: 90px;
  border-bottom: 1px solid rgba(112, 112, 112, 0.1);
}
.sumaResta,
.cantidad-eliminar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.cantidad-eliminar {
  gap: 25px;
}
.valor-producto {
  width: 79px;
  text-align: center;
  font-size: 13px;
}
#btnMenos,
#btnMas {
  background-color: #000000;
  border-radius: 4px;
  color: #fff;
  height: 30px;
  min-width: 30px;
  border: none;
  cursor: pointer;
}
#btnMenos.btn-disable {
  opacity: 0.12;
  cursor: not-allowed;
}
#btnEliminar {
  height: 35px;
  min-width: 35px;
  background-color: #fff;
  border: 1px solid #012a56;
  color: #012a56;
  border-radius: 4px;
  cursor: pointer;
}
#btnEliminar:hover {
  background-color: #012a56;
  color: #fff;
}
#btnEliminar i {
  font-size: 26px;
  color: #012a56;
}
#btnEliminar:hover i {
  color: #fff;
}
.nombre {
  width: 100%;
  min-width: 100px;
}
.contenedor-alta {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
}
.producto {
  margin-top: auto;
  color: #012a56;
  background: white;
  border: 1px solid #012a56;
  width: 210px;
}
.producto:hover {
  background: #70707050;
}
.contenedor-boton-producto{
  display: flex;
  align-self: center;
}
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@media (max-width: 767px) {
  .body-container {
    width: 100% !important;
  }
}

.no-bottom-line .v-text-field__details {
  display: none;
}
</style>
